import React from "react";

const PreviewModal = ({ isOpen, onClose, content, title }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.9)",
        display: "flex",
        flexDirection: "column",
        zIndex: 2000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          borderBottom: "1px solid rgba(59, 130, 246, 0.2)",
          background: "#050e1a",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ margin: 0, color: "#5B9EF0", fontSize: "20px" }}>
          {title || "Preview"}
        </h2>
        <button
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            color: "#7A9CC4",
            fontSize: "24px",
            cursor: "pointer",
            padding: "8px",
          }}
        >
          ✕
        </button>
      </div>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "24px",
          background: "#050e1a",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {typeof content === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          content
        )}
      </div>
    </div>
  );
};

export default PreviewModal;
